<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="广告主" prop="advertiserId">
        <el-select v-model="form.advertiserId" placeholder="请选择广告主" size="medium" filterable style="width: 100%;">
          <el-option
            v-for="item in advertiserList"
            :key="item.id"
            :label="item.advertiserName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="RTA 服务名称" prop="rtaName">
        <el-input v-model="form.rtaName" size="medium" placeholder="请输入 RTA 服务名称（如：YiDianRTA）"/>
      </el-form-item>
      <el-form-item label="Bean 名称" prop="beanName">
        <el-input v-model="form.beanName" size="medium" placeholder="请输入 Spring Bean 名称"/>
      </el-form-item>
      <el-form-item label="RTA 服务 URL" prop="rtaUrl">
        <el-input v-model="form.rtaUrl" size="medium" placeholder="请输入 RTA 服务 URL"/>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">禁用</el-radio>
          <el-radio :label="1">启用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注说明" prop="remark">
        <el-input 
          v-model="form.remark" 
          type="textarea" 
          :rows="3"
          size="medium" 
          placeholder="请输入备注说明"
          maxlength="500"
          show-word-limit/>
      </el-form-item>
    </el-form>
    <div style="text-align: right;">
      <el-button @click="close" size="medium">取消</el-button>
      <el-button @click="submit" type="primary" size="medium" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addRta, updateRta } from '@/api/ocpx/rta'
import { getEnabledAdvertiserList } from '@/api/ocpx/advertiser'

const defaultForm = {
  advertiserId: undefined,
  rtaName: undefined,
  beanName: undefined,
  rtaUrl: undefined,
  status: 1,
  remark: undefined
}

export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 700
    }
  },
  emits: ['submit'],
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, defaultForm),
      rules: {
        advertiserId: [{ required: true, message: '请选择广告主', trigger: 'change' }],
        rtaName: [{ required: true, message: '请输入 RTA 服务名称', trigger: 'blur' }],
        beanName: [{ required: true, message: '请输入 Bean 名称', trigger: 'blur' }],
        rtaUrl: [
          { required: true, message: '请输入 RTA 服务 URL', trigger: 'blur' },
          { type: 'url', message: '请输入正确的 URL 格式', trigger: 'blur' }
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      advertiserList: []
    }
  },
  computed: {
    dialogTitle () {
      return (this.title ? this.title : '') + (this.form.id ? '编辑' : '新增')
    }
  },
  created () {
    this.getAdvertiserList()
  },
  methods: {
    getAdvertiserList () {
      getEnabledAdvertiserList().then(res => {
        if (res.code === 200) {
          this.advertiserList = res.data || []
        }
      })
    },
    show (data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
      }
    },
    close () {
      this.dialogStatus = false
      this.reset()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.doUpdate(this.form)
          } else {
            this.doAdd(this.form)
          }
        }
      })
    },
    doAdd (form) {
      this.submitLoading = true
      addRta(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    doUpdate (form) {
      this.submitLoading = true
      updateRta(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset () {
      this.form = Object.assign({}, defaultForm)
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
